export const VARIANT1 = 'Fixed width sidebar with gradient background';
export const VARIANT2 = 'Responsive sidebar with gradient background';
export const VARIANT3 = 'Fixed width sidebar with white background';
export const VARIANT4 = 'Responsive sidebar with white background';
export const variantMap = {
    variant1: VARIANT1,
    variant2: VARIANT2,
    variant3: VARIANT3,
    variant4: VARIANT4,
};
